<template>
    <div>
      {{unidades}}
    <LineChartGenerator
      :chart-options="chartOptions"
      :chart-data="chartData"
    />
    </div>
   
  </template>
  
  <script>
  import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
  import zoomPlugin from 'chartjs-plugin-zoom';
  
  import annotationPlugin from 'chartjs-plugin-annotation';
  import {mapState} from 'vuex'
  import 'chartjs-adapter-moment';
  
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    LineElement,
    LinearScale,
    PointElement,
    CategoryScale,
    Legend,
    TimeScale
  
  } from 'chart.js'
  
  ChartJS.register(  Title,
    Tooltip,
    LineElement,
    LinearScale,
    PointElement,
    zoomPlugin,
    Legend,
    annotationPlugin,
    CategoryScale,
    TimeScale
  )
  
    // Deshabilitar la leyenda globalmente
  ChartJS.defaults.plugins.legend.display = false;
  
  export default {
    name: 'LineChart',
    components: {
      LineChartGenerator,
    },
    props: {
      unidades:String,
      chartData: {
        labels:Array,
        datasets: Array,
      },
      chartOptions: Object,
      plugins: {
        type: Array,
        default: () => []
      },
      tromel:Boolean,
      temp1_configuracion:String,
      temp2_configuracion:String,
    },
    methods: {
      kk(v){
        return `kk ${v}`
      }
    },
    computed: {
      ...mapState([
          'higienizacion1',
          'higienizacion2',
      ]),
    //   chartOptionsMutado() {
    //    return this.chartOptions
    //   }
  
    },
  }
  </script>